import { useReducer, useState, useContext } from "react"
import { Context } from "../store/UserProvider"

// const checkForEemil = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const checkForEemil =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const checkName = /^[a-zA-Z \u{0400}-\u{04FF}\s]+$/u
// let nextStepCounter = 0

const inputReducer = (state, action) => {
  if (action.type === "NAME") {
    return {
      text: {
        val: action.val,
        valid:
          action.val.match(checkName) && action.val.trim().length !== 0
            ? true
            : false,
      },
      email: {
        val: state.email.val,
        valid: state.email.valid,
      },
      number: {
        val: state.number.val,
        valid: state.number.valid,
      },

      password: {
        val: state.password.val,
        valid: state.password.valid,
      },

      comparePassword: {
        val: state.comparePassword.val,
        valid: state.comparePassword.valid,
      },
    }
  }

  if (action.type === "EMAIL") {
    return {
      text: {
        val: state.text.val,
        valid: state.text.valid,
      },
      email: {
        val: action.val,
        valid:
          action.val.match(checkForEemil) && action.val.trim().length !== 0
            ? true
            : false,
      },
      number: {
        val: state.number.val,
        valid: state.number.valid,
      },

      password: {
        val: state.password.val,
        valid: state.password.valid,
      },

      comparePassword: {
        val: state.comparePassword.val,
        valid: state.comparePassword.valid,
      },
    }
  }

  if (action.type === "TEL") {
    return {
      text: {
        val: state.text.val,
        valid: state.text.valid,
      },
      email: {
        val: state.email.val,
        valid: state.email.valid,
      },
      number: {
        val: action.val,
        valid: action.val.length < 9 || action.val.length > 9 ? false : true,
      },

      password: {
        val: state.password.val,
        valid: state.password.valid,
      },

      comparePassword: {
        val: state.comparePassword.val,
        valid: state.comparePassword.valid,
      },
    }
  }

  if (action.type === "PASS") {
    return {
      text: {
        val: state.text.val,
        valid: state.text.valid,
      },
      email: {
        val: state.email.val,
        valid: state.email.valid,
      },
      number: {
        val: state.number.val,
        valid: state.number.valid,
      },

      password: {
        val: action.val,
        valid: action.val.length < 6 ? false : true,
      },

      comparePassword: {
        val: state.comparePassword.val,
        valid: state.comparePassword.valid,
      },
    }
  }

  if (action.type === "PASS_CHECK") {
    return {
      text: {
        val: state.text.val,
        valid: state.text.valid,
      },
      email: {
        val: state.email.val,
        valid: state.email.valid,
      },
      number: {
        val: state.number.val,
        valid: state.number.valid,
      },

      password: {
        val: state.password.val,
        valid: state.password.valid,
      },

      comparePassword: {
        val: action.val,
        // valid: action.val.length < 3 ? false : true,
        valid:
          action.val !== state.password.val || action.val.length < 6
            ? false
            : true,
      },
    }
  }

  return {
    text: {
      val: "",
      valid: true,
    },
    email: {
      val: "",
      valid: true,
    },
    number: {
      val: "",
      valid: true,
    },
    password: {
      val: "",
      valid: true,
    },

    comparePassword: {
      val: "",
      valid: true,
    },
  }
}

const useValidate = (mode = "NO-MODE") => {
  const ctx = useContext(Context)
  const [inputState, dispatchInput] = useReducer(inputReducer, {
    text: {
      val: "",
      valid: true,
    },
    email: {
      val: "",
      valid: true,
    },
    number: {
      val: "",
      valid: true,
    },
    password: {
      val: "",
      valid: true,
    },

    comparePassword: {
      val: "",
      valid: true,
    },
  })

  const [submit, setSubmit] = useState(false)
  const [terms, setTerms] = useState(false)
  const [forgottenPass, setForgottenPass] = useState(false)

  const checkboxHandler = event => {
    if (event.target.checked) {
      setTerms(true)
    } else {
      setTerms(false)
    }
  }

  const inputHandler = event => {
    if (event.target.dataset.id === "text") {
      dispatchInput({ type: "NAME", val: event.target.value })
    } else if (event.target.dataset.id === "email") {
      dispatchInput({ type: "EMAIL", val: event.target.value })
    } else if (event.target.dataset.id === "number") {
      dispatchInput({ type: "TEL", val: event.target.value })
    } else if (event.target.dataset.id === "password") {
      dispatchInput({ type: "PASS", val: event.target.value })

      if (mode === "SIGN-UP") {
        dispatchInput({
          type: "PASS_CHECK",
          val: inputState.comparePassword.val,
        })
      }
    } else if (event.target.dataset.id === "comparePassword") {
      dispatchInput({ type: "PASS_CHECK", val: event.target.value })
    }
  }

  const formHandler = event => {
    event.preventDefault()
    setSubmit(true)

    if (mode === "SIGN-UP") {
      if (
        terms &&
        inputState.email.valid &&
        inputState.email.val &&
        inputState.password.valid &&
        inputState.password.val &&
        inputState.comparePassword.valid &&
        inputState.comparePassword.val &&
        inputState.text.valid &&
        inputState.text.val
      ) {
        const userData = {
          userName: inputState.text.val,
          email: inputState.email.val,
          pass: inputState.password.val,
        }
        ctx.sendAccData(userData)
        // if (!ctx.errorState.error) {
        //   dispatchInput({ type: "RESET_INPUT" })
        // }
      } else {
        dispatchInput({ type: "NAME", val: inputState.text.val })
        dispatchInput({ type: "EMAIL", val: inputState.email.val })
        dispatchInput({ type: "PASS", val: inputState.password.val })
        dispatchInput({
          type: "PASS_CHECK",
          val: inputState.comparePassword.val,
        })

        console.log("invalid input")
      }
    }

    if (mode === "LOG-IN") {
      if (
        inputState.email.valid &&
        inputState.email.val &&
        inputState.password.valid &&
        inputState.password.val
      ) {
        const userData = {
          email: inputState.email.val,
          pass: inputState.password.val,
        }
        ctx.logInHandler(userData)
        // dispatchInput({ type: "RESET_INPUT" })
      } else {
        dispatchInput({ type: "EMAIL", val: inputState.email.val })
        dispatchInput({ type: "PASS", val: inputState.password.val })
        console.log("invalid input")
      }
    }

    if (mode === "CONTACT") {
      if (
        inputState.text.valid &&
        inputState.email.valid &&
        inputState.number.valid &&
        inputState.text.val &&
        inputState.email.val &&
        inputState.number.val
      ) {
        const userData = {
          name: inputState.text.val,
          email: inputState.email.val,
          number: `0${inputState.number.val}`,
        }
        console.log(userData)
        dispatchInput({ type: "RESET_INPUT" })
      } else {
        dispatchInput({ type: "NAME", val: inputState.text.val })
        dispatchInput({ type: "EMAIL", val: inputState.email.val })
        dispatchInput({ type: "TEL", val: inputState.number.val })
        console.log("invalid input")
      }
    }
  }

  const resolveInputServerError = event => {
    if (
      event.target.dataset.id === "email" &&
      ctx.errorState.error.have &&
      ctx.errorState.error.message === "Email is already taken"
    ) {
      setSubmit(false)
      dispatchInput({ type: "EMAIL", val: "" })
      ctx.resetError()
      setTerms(false)
    } else if (
      (event.target.dataset.id === "email" ||
        event.target.dataset.id === "password") &&
      ctx.errorState.error.have &&
      (ctx.errorState.error.message === "Invalid identifier or password" ||
        ctx.errorState.error.message === "Your account email is not confirmed")
    ) {
      ctx.resetError()
    } else if (event.target.dataset.id === "text" && ctx.nameDuplication) {
      setSubmit(false)
      setTerms(false)
      dispatchInput({ type: "NAME", val: "" })
      ctx.resetError()
      ctx.resetNameDupCheck()
    } else if (
      event.target.dataset.id === "email" &&
      ctx.errorState.error.have &&
      ctx.errorState.error.message === "This email does not exist"
    ) {
      setSubmit(false)
      dispatchInput({ type: "EMAIL", val: "" })
      ctx.resetError()
    }
  }

  const resetData = () => {
    dispatchInput({ type: "RESET_INPUT" })
    setSubmit(false)
  }

  const ForgottenPassSwitch = () => {
    resetData()
    setForgottenPass(!forgottenPass)
  }

  const forgottenPassFromHandler = (token, event) => {
    event.preventDefault()
    setSubmit(true)
    console.log(token)

    if (mode === "RESET-PASS") {
      if (
        token &&
        inputState.password.valid &&
        inputState.password.val &&
        inputState.comparePassword.valid &&
        inputState.comparePassword.val
      ) {
        const userData = {
          pass: inputState.password.val,
          token: token,
        }
        ctx.changeForgottenPasss(userData)
      } else {
        dispatchInput({ type: "PASS", val: inputState.password.val })
        dispatchInput({
          type: "PASS_CHECK",
          val: inputState.comparePassword.val,
        })
      }
    } else {
      if (inputState.email.valid && inputState.email.val) {
        const userData = inputState.email.val

        ctx.sendForgottenPasss(userData)
        // dispatchInput({ type: "RESET_INPUT" })
      } else {
        dispatchInput({ type: "EMAIL", val: inputState.email.val })
        console.log("invalid input")
      }
    }
  }

  return {
    inputHandler: inputHandler,
    formHandler: formHandler,
    resetData: resetData,
    resolveInputServerError: resolveInputServerError,
    checkboxHandler: checkboxHandler,
    ForgottenPassSwitch: ForgottenPassSwitch,
    forgottenPassFromHandler: forgottenPassFromHandler,
    terms: terms,
    inputState: inputState,
    submit: submit,
    forgottenPass: forgottenPass,
  }
}

export default useValidate
